import React from 'react';
import ReactDOM from 'react-dom/client';


import '../../main/scss/index.scss';
import 'normalize.css';
import { ScanDemo } from './ScanDemo';

const app = ReactDOM.createRoot(document.getElementById('app'));
app.render(<ScanDemo />);
